import { ComponentPortal } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, inject, Injector } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';
import { ChatStore } from '@coin/chat-bot-data-access';
import { CocoCelebrationService } from '@coin/chat-bot-util-types';
import { AuthService } from '@coin/shared/auth/data-access';
import { FeatureFlagsService } from '@coin/shared/core/data-access';
import { ChatDialogComponent } from '../chat-dialog/chat-dialog.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'coin-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrl: './chat-bot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, TranslateModule],
  providers: [CocoCelebrationService],
  host: {
    'animate.enter': 'fade-in'
  }
})
export class ChatBotComponent {
  private readonly chatStore = inject(ChatStore);
  private readonly injector = inject(Injector);
  private readonly featureFlagsService = inject(FeatureFlagsService);
  private readonly authService = inject(AuthService);
  protected readonly isActiveFeature = this.featureFlagsService.isActive('chatBot');
  protected readonly isAuthenticated = toSignal(this.authService.isAuthenticated$, { initialValue: false });
  private readonly componentPortal = new ComponentPortal(ChatDialogComponent, null, this.injector);

  constructor() {
    this.chatStore.setChatDialogComponent(this.componentPortal);
  }

  toggleChat() {
    this.chatStore.toggle();
  }
}
